import styled from 'styled-components';
import { Button, grubhubLight, Squish } from '@grubhubprod/gh-cookbook-react';

export const StyledDropdownSquare = styled(Squish)`
  cursor: pointer;
  &:hover {
    background-color: ${grubhubLight.colors.tintedBackground};
  }
`;

export const StyledDropdownButton = styled(Button)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  text-align: left;
  color: ${grubhubLight.colors.secondaryText};
`;
